import { Action } from '@ngrx/store';

export function getSelectionSuccessType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Get Selection Success for ${(type as any).$typeName}`;
}

export class GetSelectionSuccessAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { model: TModel } | any) {
    this.type = getSelectionSuccessType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/GetSelectionSuccessAction.ts